import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineAsyncComponent } from "vue";
import { useHR } from "./hooks/useHR";


export default /*#__PURE__*/_defineComponent({
  __name: 'HR',
  setup(__props) {

const Sectors = defineAsyncComponent(
  () => import("@/components/hr/sector/Sectors.vue")
);
const Functions = defineAsyncComponent(
  () => import("@/components/hr/function/Functions.vue")
);

const Employees = defineAsyncComponent(
  () => import("@/components/hr/employee/Employees.vue")
);

const Pointings = defineAsyncComponent(
  () => import("@/components/hr/pointing/Pointings.vue")
);

const { active, saveActive } = useHR();

return (_ctx: any,_cache: any) => {
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createBlock(_component_TabView, {
    lazy: "",
    "active-index": _unref(active),
    "onUpdate:activeIndex": _unref(saveActive)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_TabPanel, { header: "Secteurs" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Sectors))
        ]),
        _: 1
      }),
      _createVNode(_component_TabPanel, { header: "Fonctions" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Functions))
        ]),
        _: 1
      }),
      _createVNode(_component_TabPanel, { header: "Employés" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Employees))
        ]),
        _: 1
      }),
      _createVNode(_component_TabPanel, { header: "Pointages" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Pointings))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["active-index", "onUpdate:activeIndex"]))
}
}

})